import React, { useEffect } from 'react';
import Container from "@mui/material/Container";
import './home.css';
import JumbotronComponent from "./JumbotronComponent";
import EventKeynoteComponent from './EventKeynoteComponent';
import { useGlobal } from '../../utils/GlobalContext';
import { useNavigate } from 'react-router-dom';
import PreviousKeynoteComponent from './PreviousKeynoteComponent';
  
export default function Home() {
    const { state } = useGlobal();
    const navigate = useNavigate();
    if (state.UserProfile.IsExistingUser === false) {
      navigate("/account");
  }
    return (
        <>
            <div className="container">
                <Container maxWidth="xl">
                    <JumbotronComponent/>
                    <EventKeynoteComponent/>
                    <PreviousKeynoteComponent/>
                </Container>      
                <br/>
                <br/>
                <br/>
            </div>
        </>
    )
}